import React from 'react';
interface SectionHeadingProps {
  eyebrow?: string;
  icon?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
}
export function SectionHeading({
  eyebrow,
  icon,
  title,
  description,
  className = ''
}: SectionHeadingProps) {
  return <div className={`mx-auto max-w-2xl text-center ${className}`} data-id="element-168" data-mp="3jzx7u9uywqu5">
      {eyebrow && <p className="mb-4 text-[11px] font-semibold uppercase tracking-[0.22em] text-tr-grey/70" data-id="element-169" data-mp="bkn6j3ywjpnf">
          {eyebrow}
        </p>}
      <h2 className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-[1.75rem] font-bold leading-[1.15] tracking-tight text-tr-navy sm:text-4xl md:text-[2.6rem]" data-id="element-170" data-mp="gif002f73jtq">
        {icon}
        <span data-id="element-171" data-mp="6sln8y3bgynw">{title}</span>
      </h2>
      {description && <p className="mx-auto mt-5 max-w-xl text-[15px] leading-relaxed text-tr-grey md:text-base" data-id="element-172" data-mp="ujhm2f66wu4n">
          {description}
        </p>}
    </div>;
}